import React from "react"
import Svg from "../../../shared/_svgs/svg"
import config from "react-global-configuration"
import OutsideClickTrigger from "../../components/common/OutsideClickTrigger"

export default function ActionModal({ closeModal, actionMethod, confirmActionHeader, confirmText, confirmButton }) {
  const textKeys = config.get("textKeys.amendment.manage") || {}
  // console.log(textKeys);
  return (
    <div className="overlay overlay--modal overlay--fixed is-active">
      <div className="modal">
        <OutsideClickTrigger onOutsideClick={closeModal}>
          <button className="button button--icon js--close-modal" onClick={closeModal}>
            <Svg iconName="close-new" />
          </button>
          <div className="modal__content">
            <div className="modal__content__inner">
              <div className="modal__middle rich-text">
                <h3>{confirmActionHeader || "Er du sikker?"}</h3>
                <p>{confirmText || "Tryk på 'Bekræft' for at bekræfte din handling."}</p>
                <hr />
                <div className="center-button">
                  <button className="button button--medium button--negative rm-this-class rm-this-class-hide-default wider" onClick={actionMethod}>
                    {confirmButton || "Bekræft"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </OutsideClickTrigger>
      </div>
    </div>
  )
}
